import React from 'react';

const partners = [
  {
    name: 'Supabase',
    role: 'Databaseinfrastruktur & Autentisering',
    data: 'Brukerkontodata, autentiseringstokens, applikasjonsdata',
    location: 'EU (Frankfurt)',
    basis: 'Databehandleravtale',
    link: 'https://supabase.com/privacy'
  },
  {
    name: 'Stripe',
    role: 'Betalingsbehandling',
    data: 'Betalingsinformasjon (tokenisert), faktureringsadresse',
    location: 'EU/USA (Standard Contractual Clauses)',
    basis: 'Databehandleravtale',
    link: 'https://stripe.com/privacy'
  },
  {
    name: 'Vercel / Netlify',
    role: 'Webhosting & CDN',
    data: 'IP-adresser, HTTP-forespørsler, ytelsesdata',
    location: 'EU',
    basis: 'Databehandleravtale',
    link: '#'
  },
  {
    name: 'Google Analytics',
    role: 'Nettstedsanalyse',
    data: 'Anonymiserte bruksdata, sidevisninger, sesjonsdata',
    location: 'EU (IP-anonymisering aktivert)',
    basis: 'Samtykke (art. 6(1)(a))',
    link: 'https://policies.google.com/privacy'
  },
];

const ThirdPartySection = () => {
  return (
    <section id="tredjepart" style={{ marginBottom: '80px' }}>
      <div style={{ marginBottom: '40px', position: 'relative' }}>
        <div
          style={{
            fontFamily: 'Impact, sans-serif',
            fontSize: 'clamp(4rem, 10vw, 8rem)',
            fontWeight: 900,
            color: 'rgba(249,115,22,0.05)',
            lineHeight: 1,
            position: 'absolute',
            top: '-20px',
            left: '-10px',
            userSelect: 'none',
            letterSpacing: '-0.04em'
          }}
        >
          04
        </div>
        <div style={{ position: 'relative', zIndex: 1 }}>
          <div
            style={{
              fontFamily: 'JetBrains Mono, monospace',
              fontSize: '0.6875rem',
              color: '#F97316',
              letterSpacing: '0.15em',
              textTransform: 'uppercase',
              marginBottom: '8px'
            }}
          >
            § 4 — TREDJEPARTER
          </div>
          <h2
            style={{
              fontFamily: 'Impact, sans-serif',
              fontSize: 'clamp(1.75rem, 4vw, 3rem)',
              fontWeight: 900,
              color: '#EEF0F2',
              textTransform: 'uppercase',
              letterSpacing: '-0.02em',
              lineHeight: 1
            }}
          >
            Tredjepartstjenester
          </h2>
        </div>
      </div>
      <p
        style={{
          fontFamily: 'Georgia, serif',
          fontSize: '1.0625rem',
          color: 'rgba(238,240,242,0.7)',
          lineHeight: 1.8,
          marginBottom: '32px',
          maxWidth: '720px'
        }}
      >
        Vi deler personopplysninger med utvalgte tredjeparter kun i den grad det er nødvendig 
        for å levere tjenestene. Alle tredjeparter er bundet av databehandleravtaler i henhold 
        til GDPR artikkel 28.{' '}
        <a
          href="/terms-conditions-vilk-r-betingelser#tjenester"
          style={{ color: '#F97316', textDecoration: 'underline', textDecorationColor: 'rgba(249,115,22,0.4)' }}
        >
          Se våre Vilkår & Betingelser for tjenestebeskrivelse →
        </a>
      </p>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
        {partners?.map((p, i) => (
          <div
            key={i}
            style={{
              background: 'rgba(255,255,255,0.02)',
              border: '1px solid rgba(255,255,255,0.06)',
              padding: '24px',
              display: 'grid',
              gridTemplateColumns: '200px 1fr 1fr auto',
              gap: '24px',
              alignItems: 'start'
            }}
          >
            <div>
              <div
                style={{
                  fontFamily: 'Syne, sans-serif',
                  fontSize: '1rem',
                  fontWeight: 800,
                  color: '#EEF0F2',
                  marginBottom: '4px'
                }}
              >
                {p?.name}
              </div>
              <div
                style={{
                  fontFamily: 'Inter, sans-serif',
                  fontSize: '0.75rem',
                  color: '#3B6FD4'
                }}
              >
                {p?.role}
              </div>
            </div>
            <div>
              <div
                style={{
                  fontFamily: 'JetBrains Mono, monospace',
                  fontSize: '0.625rem',
                  color: 'rgba(138,149,163,0.5)',
                  letterSpacing: '0.08em',
                  textTransform: 'uppercase',
                  marginBottom: '4px'
                }}
              >
                Data som deles
              </div>
              <p
                style={{
                  fontFamily: 'Inter, sans-serif',
                  fontSize: '0.8125rem',
                  color: 'rgba(238,240,242,0.65)',
                  lineHeight: 1.5,
                  margin: 0
                }}
              >
                {p?.data}
              </p>
            </div>
            <div>
              <div
                style={{
                  fontFamily: 'JetBrains Mono, monospace',
                  fontSize: '0.625rem',
                  color: 'rgba(138,149,163,0.5)',
                  letterSpacing: '0.08em',
                  textTransform: 'uppercase',
                  marginBottom: '4px'
                }}
              >
                Lokasjon
              </div>
              <p
                style={{
                  fontFamily: 'Inter, sans-serif',
                  fontSize: '0.8125rem',
                  color: 'rgba(238,240,242,0.65)',
                  lineHeight: 1.5,
                  margin: 0
                }}
              >
                {p?.location}
              </p>
            </div>
            <div>
              <div
                style={{
                  fontFamily: 'JetBrains Mono, monospace',
                  fontSize: '0.625rem',
                  color: 'rgba(138,149,163,0.5)',
                  letterSpacing: '0.08em',
                  textTransform: 'uppercase',
                  marginBottom: '6px'
                }}
              >
                Grunnlag
              </div>
              <div
                style={{
                  fontFamily: 'Inter, sans-serif',
                  fontSize: '0.75rem',
                  color: '#10B981',
                  background: 'rgba(16,185,129,0.08)',
                  border: '1px solid rgba(16,185,129,0.2)',
                  padding: '3px 8px',
                  marginBottom: '8px'
                }}
              >
                {p?.basis}
              </div>
              <a
                href={p?.link}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  fontFamily: 'Inter, sans-serif',
                  fontSize: '0.6875rem',
                  color: 'rgba(59,111,212,0.7)',
                  textDecoration: 'none'
                }}
              >
                Personvernerklæring →
              </a>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ThirdPartySection;
